import { AnalyticsEventName } from 'api/analytics';
import { DownloadAndroidApp } from 'components/DownloadAndroidApp';
import { useAnalytics } from 'helpers/analytics';

import { ScDownloadButtons } from './styled';

export const DownloadButtons = () => {
  const { sendEventToAnalytics } = useAnalytics();

  const handleAndroidClick = () => {
    sendEventToAnalytics({
      name: AnalyticsEventName.FOOTER__ANDROID_APP_ICON__LINK__CLICK,
    });
  };

  return (
    <ScDownloadButtons>
      <DownloadAndroidApp onClick={handleAndroidClick} />
    </ScDownloadButtons>
  );
};
